'use client';

import { useEffect } from 'react';
import { clearCliStash } from '@/lib/utils/cliAuth';
import LoginStatus from './LoginStatus';

// `to` comes from resolvePostLoginDestination only, never straight from the URL.
export default function CliFinish({ to }: { to: string }) {
  useEffect(() => {
    // A leftover stash would push the next sign-in on this browser into the CLI flow.
    clearCliStash();
    window.location.replace(to);
  }, [to]);

  return <LoginStatus />;
}
